export default "__VITE_ASSET__Bxhc454J__"